/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ProSidebar, SidebarHeader, SidebarContent } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import * as Icon from 'react-bootstrap-icons';
import '../assets/styles/Sidebar.scss';
import arrow from "../assets/Images/arrow.svg";
import PoleInformation from "./PoleInformation";
import MapFilter from "./MapFilter";
import Images from "./Images";
import { RepairCategoriesApi, getPoleData } from "../services/api";
import { schoolType, prioritiesType } from "../types/customTypes";
import { toast } from "react-toastify";

export interface Props {
	poleid: unknown;
	resetPoleDataOne: () => void;
	schools: schoolType;
	priorities: prioritiesType;
	setCenter: (hash, zoomValue) => void;
	setPriorities: (a) => void;
	refreshMap: () => void;
	selectedSchool: string;
	updatePoleData: (poleData: unknown) => void;
	updateFilteredSchools: (schools: schoolType) => void;
	getMapImage: () => void;
	controlImageCreation : (a) => void;
	map: unknown;
}

const Sidebar: React.FC<Props> = (props: Props) => {
	const [menuCollapse, setMenuCollapse] = useState(false);
	const [activeTab, setActiveTab] = useState('MapFilter'); 
	const [data, setData] = useState([]);
	const [recommendation, setRecommendation] = useState([]);
	const [comments, setComments] = useState(null);
	const [replacementHistory, setReplacementHistory] = useState([]);
	const [images, setImages] = useState([]);
	const [isloading, setIsLoading] = useState(true);
	const [imgLength, setImgLength] = useState(0);
	const [counter, setCounter] = useState(0);
	const [failedimg, setFailedimg] = useState(0);
	const [imageFiles, setImageFiles] = useState([]);
	const [isPoleReplacement, setIsPoleReplacement] = useState({ isPoleReplacement: false, poleReplacementRepairId: null });
	const [otherRepairId, setOtherRepairId] = useState(null);


	const menuIconClick = () => {
		menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);
	};

	const isActiveTab = (tab) => {
		return tab === activeTab && 'text-decoration-underline';
	};

	const poleData = () => {
		getPoleData(props.poleid).then(response => {
			setImages(response.poleData.imgFiles.sort(i=>i.priority==='high' ? -1 : 1));
			props.updatePoleData(response.poleData);
			setData([response.poleData]);
			setRecommendation([response.poleRecommendation]); 
			setComments([...(response.comments)]);
			setReplacementHistory(response.replacementHistory);
			setImageFiles(response.poleData.imgFiles);
		}).catch(err => {
			console.error(err);
			toast.error(err)
		});
	};

	const checkPoleDescription = async () => {
		try {
			const repairDataResponse = await RepairCategoriesApi(props.poleid);
			if (repairDataResponse.ok) {
				const repairData = await repairDataResponse.json();
				const matchingRepair = repairData.find((repair) => repair.description === "Pole Replacement");
				const matchingOtherRepair = repairData.find((repair) => repair.description === "Other");

				if (matchingRepair) {
					const poleReplacementRepairId = matchingRepair.repairCategoryId;
					setIsPoleReplacement({ isPoleReplacement: true, poleReplacementRepairId });
				} else {
					setIsPoleReplacement({ isPoleReplacement: false, poleReplacementRepairId: null });
				}

				if (matchingOtherRepair) {
					const otherRepairId = matchingOtherRepair.repairCategoryId;
					setOtherRepairId(otherRepairId); // Example: set state for "Other" repair ID
				} else {
					setOtherRepairId(null);
				}
			} else {
				toast.error("Failed to fetch repair data.");
			}
		} catch (error) {
			toast.error(error);
		}
	};

	useEffect(() => {
		if (props.poleid && props.poleid !== 0) {  //reseting data for new pole id and navigating to pole info tab
			setImages([]);
			setFailedimg(0); setCounter(0);
			props.resetPoleDataOne();
			setIsLoading(true);
			poleData();  //calling pole data function
			setActiveTab('PoleInformation');
			setMenuCollapse(false);
			checkPoleDescription(); // Check if pole description matches "Pole Replacement"
		}
		else if (props.poleid === 0) { //reseting data for null pole id and navigating to map filter tab
			setActiveTab('MapFilter');
			setImages([]);setData([]); setRecommendation([]); setComments(null); setReplacementHistory([]);
			setImgLength(0); setFailedimg(0); setCounter(0);
			props.resetPoleDataOne();
			setIsLoading(true);
		}
	}, [props.poleid])

	useEffect(() => {   //adding failed images as failedimg or counter value get changed
		if (failedimg + counter == imgLength) {
			setIsLoading(false);
		}
	}, [failedimg, counter])


	const imageLoaded = () => {  //calls whenever image is fully load in image tab
		setCounter(counter + 1);
		if (counter === imgLength - 1) {  // to stop spinner when all image loaded
			setIsLoading(false);
		}
	}

	const collapseSidebar = () => {
		if (window.innerWidth < 991) {
			menuIconClick();
		}
	}

	useEffect(() => {
		collapseSidebar();
	}, [])

	return (
		<div id="header" className="sidebar-header">
			<ProSidebar collapsed={menuCollapse} className={menuCollapse ? 'prosidebar-header' : ''}>
				<SidebarHeader>
					<div className="closemenu" data-testid="closemenu" id="closemenu" onClick={menuIconClick} >
						{menuCollapse ?
							<Icon.List className="icon mx-2" id="icon" /> :
							<img className="icons position-absolute top-0 end-0 mx-2 mt-1 border" data-testid="arrow-img" src={arrow} alt="" />
						}
					</div>

					<div className="row text-dark tabs mt-3" id="tabs">
						<div className={`col title text-center ${isActiveTab('MapFilter')}`} data-testid="filter-tabs" onClick={() => { setActiveTab('MapFilter'); }}> FILTERS </div>
						<div className={`col title text-center ${isActiveTab('PoleInformation')}`} data-testid="info-tabs" onClick={() => { setActiveTab('PoleInformation'); }}> INFORMATION </div>
						<div className={`col title text-center ${isActiveTab('Images')}`} data-testid="img-tabs" onClick={() => { setActiveTab('Images'); }}> IMAGES </div>
					</div>
				</SidebarHeader>

				<SidebarContent className="m-2 mt-3" data-testid="content">
					{activeTab === 'PoleInformation' &&
						<PoleInformation data={data}
							recommendation={recommendation}
							replacementHistory={replacementHistory}
							comments={comments? comments.reverse():null}
							isPoleReplacement={isPoleReplacement}
							poleid={props.poleid}
							refreshPoleData={poleData}
							refreshRepaireMatrix={checkPoleDescription}
							otherRepairId={otherRepairId} 
						/>
					}
					<div className={activeTab === 'MapFilter' ? 'd-inline' : 'hide'}>
						<MapFilter 
							{...props} 
							collapseSidebar={collapseSidebar} 
							controlImageCreation ={props.controlImageCreation } 
							map={props.map} 
						/>
					</div>
					{activeTab === 'Images' &&
						<Images
							images={images}
							imageFiles={imageFiles}
							poleid={props.poleid}
							isloading={isloading}
							imageLoaded={imageLoaded}
							highPriority={data.map(x => x.high)}
							replacementHistory={replacementHistory}
							isPoleReplacement={isPoleReplacement}
							refreshPoleData={poleData}
						/>
					}
				</SidebarContent> 
			</ProSidebar>
		</div>
	);
};

export default Sidebar;